var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 167 34",
    style: {
      enableBackground: "new 0 0 167 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.4,6.1c-1.7,0-3.4,0.7-4.6,1.9c-1.2,1.2-1.9,2.9-1.9,4.6s0.7,3.4,1.9,4.6c1.2,1.2,2.9,1.9,4.6,1.9 c3.5,0,7,0,10.6,0c1.2,0,2.2,1,2.2,2.2c0,1.2-1,2.2-2.2,2.2c-5.3,0-10.7,0-16,0v4.4h16.5c1.8,0,3.5-0.7,4.7-2 c1.3-1.3,2-2.9,1.9-4.7c0-1.8-0.7-3.5-2-4.7s-3-1.9-4.7-1.9c-3.5,0-7,0-10.6,0c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1 c5.4,0,10.9,0,16.3,0c0-1.5,0-3,0-4.4C130.6,6.1,125,6.1,119.4,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.2,6.1v14.5L5.3,6.1H0v21.8h5.3V13.4l15.9,14.5h5.3V6.1H21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.6,6.1h-5.2v21.8h18v-4.4H53.6L53.6,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.9,6.1L149,15.4V6.1h-5.2v21.8h5.2v-9.7l11.2,9.7h6.8l-12.8-11.2h0L167,6.1H159.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101,6.1h5.2v21.8H101V6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.4,19.1v-4.4H78.8v-4.1h15.1V6.1H73.5v21.8h5.2v-8.8L90.4,19.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.9,6.1h5.2v21.8h-5.2V6.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bf295c8b468b613471026cac1c61ce6a.svg";
export { ForwardRef as ReactComponent };